const Image = {
  isComponent: el => el.tagName === 'IMG',
  extend: 'image',
  model: {
    defaults: Object.assign({}, {
      tagName: 'img',
      draggable: true,
      droppable: true,
      copyable: true,
      attributes: {
        id: 'image'
      },
      traits: [
        {
          name: 'id',
          label: 'ID',
          placeholder: 'ID',
          type: 'text'
        },
        {
          name: 'src',
          label: 'Source',
          placeholder: 'Source',
          type: 'text'
        }
      ]
    })
  }
}

export default Image
